(function ($, Cobalt, undefined) {
    Cobalt.Attachment =
    {
        initialize: function () {
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find(".j-attachments-form")
            .each(function () {
                var $form = $(this);
                var $fileInput = $form.find("input.j-multi-file-upload");
                $fileInput.disable();

                $form.find("#field-title")
                    .keypress(function () {
                        var $field = $(this);
                        setTimeout(function () {
                            if ($field.valid()) {
                                $fileInput.enable();
                            } else {
                                $fileInput.disable();
                            }
                        }, 1);
                    });

                var submitted = null;
                $fileInput
                    .change(function () {
                        setTimeout(function () {
                            if (submitted && submitted >= +new Date) {
                                return;
                            }
                            submitted = 500 + new Date;
                            if ($fileInput.val() && $fileInput.is(":enabled")) {
                                $form.submit();
                            }
                        }, 17);
                    });
            });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Attachment.js